import { useFormContext } from "react-hook-form";

import { MultiSelectQuestion } from "../components/MultiSelectQuestion";
import { SurveyStepLayout } from "../components/SurveyStepLayout";
import { type ScreeningSurveyFormData } from "../lib/screeningSurveySchema";
import { type SpecialtyCare, specialtyCareLabels } from "../lib/screeningSurveyTypes";

const options = Object.entries(specialtyCareLabels).map(([value, label]) => ({
  value: value as SpecialtyCare,
  label,
}));

interface SpecialtyCareStepProps {
  onContinue: () => void;
  onBack: () => void;
  currentStep: number;
  totalSteps: number;
}

export function SpecialtyCareStep(props: SpecialtyCareStepProps) {
  const { onContinue, onBack, currentStep, totalSteps } = props;
  const { watch, setValue } = useFormContext<ScreeningSurveyFormData>();
  const value = watch("specialtyCareExperience") ?? [];

  return (
    <SurveyStepLayout
      currentStep={currentStep}
      totalSteps={totalSteps}
      title="Do you have at least 6 months experience with any of the following?"
      subtitle="Select all that apply."
      continueDisabled={value.length === 0}
      onBack={onBack}
      onContinue={onContinue}
    >
      <MultiSelectQuestion
        options={options}
        selectedValues={value}
        onChange={(v) => {
          setValue("specialtyCareExperience", v);
        }}
      />
    </SurveyStepLayout>
  );
}
